<template>
  <div class="stage stage-3">
    <div class="stage-header">
      <h3>03: WORKOUT</h3>
    </div>
    <div class="stage-body">
      <div class="details activity-details">
        <label>Workouts or Post *</label>
        <select
          v-model="workoutChoice"
          :class="{ error: errors.workoutChoice }"
        >
          <option value="" disabled>Workout</option>
          <option value="post">Post</option>
          <option v-for="workout in workouts" :value="workout.id" :key="workout.id">{{ workout.title }}</option>
        </select>

        <div v-if="workoutChoice !== 'post'" class="slider">
          <label>Overall Workout Effort Level</label>
          <vue-slider 
            v-model="workoutDifficulty"
            :min="1"
            :max="10" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  name: "WorkoutDetails",
  
  props: {
    errors: {
      type: Object,
      required: true,
    }
  },

  components: {
    VueSlider,
  },

  computed: {
    workoutChoice: {
      get () {
        return this.$store.state.activity.workoutChoice
      },
      set (value) {
        this.$store.commit('activity/updateAttribute', {value: value, type: 'workoutChoice'})
      }
    },

    workoutDifficulty: {
      get () {
        return this.$store.state.activity.workoutDifficulty
      },
      set (value) {
        this.$store.commit('activity/updateAttribute', {value: value, type: 'workoutDifficulty'})
      }
    },

    workouts() {
      return this.$store.state.activity.workouts;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";
@import "@/assets/css/internal";

.stage {
  width: 100%;
  padding-bottom: $spacing-base;

  .stage-header {
    padding: $spacing-base;
    display: flex;
    h3 {
      font-size: 14px;
      font-weight: 700;
      padding: 0;
      margin: 0;
      color: white;
    }
  }

  .stage-body {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-left: $spacing-base;
    
    .activity-details {
      max-width: 600px;
      
      p {
        color: $sec4;
        font-weight: 500;
        font-size: 14px;
        padding: 0;
        margin: 0;
      }

      .slider {
        margin-top: $spacing-base;
      }
    }

    .details {
      padding: $spacing-base;
      padding-top: 0;
      display: flex;
      flex-direction: column;

      .detail-row {
        display: flex;
        margin-top: $spacing-base;
        flex-direction: row;
        gap: $spacing-base;

        .detail-col {
          flex: 1;
          display: flex;
          flex-direction: column;
        }
      }

      label {
        font-weight: 500;
        font-size: 14px;
        color: $sec5;
        margin-top: $spacing-base;
      }

      label:first-of-type {
        margin-top: 0;
      }
    }

    .section-header {
      display: flex;
      flex-direction: row;
      padding: $spacing-base;
      h3 {
        margin: 0;
        padding: 0;
        font-weight: 500;
        color: $sec0;
        font-size: 1em;
      }
    }
  }
}
</style>
